// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"123":"case","357":"casesFrame","794":"cases","933":"auth"}[chunkId] || chunkId) + "." + {"123":"e09db433","163":"a6e4c756","288":"d523e777","357":"f0112103","508":"9ec37923","794":"d7f3143e","854":"f5a9768e","865":"2b9029f9","915":"6fb4a13e","933":"48ad23e3","986":"279b84e9"}[chunkId] + ".js";
};